import type { AppRouter } from "@repo/vihangam-yog-backend/router";
import type { inferRouterInputs } from "@trpc/server";

/** The values the backend's `registerEventBundle` accepts for `lastHawan`. */
type BundleLastHawan = NonNullable<
  inferRouterInputs<AppRouter>["registerEventBundle"]["lastHawan"]
>;

/** The five answers, in the order the pills render. Checked against the
 *  backend's enum so a value the form offers is one the server takes. */
export const LAST_HAWAN_OPTIONS = [
  "within_month",
  "within_6_months",
  "within_year",
  "over_year",
  "never",
] as const satisfies readonly BundleLastHawan[];

export type LastHawan = (typeof LAST_HAWAN_OPTIONS)[number];

const LAST_HAWAN_LABELS = {
  within_month: "Within a month",
  within_6_months: "Within 6 months",
  within_year: "Within a year",
  over_year: "More than a year ago",
  never: "Never",
} satisfies Record<LastHawan, string>;

/** The pill wording for a stored answer. */
export function lastHawanLabel(value: LastHawan): string {
  return LAST_HAWAN_LABELS[value];
}

/** True when `value` is one of the five answers; the draft in
 *  sessionStorage and the ticket from the server both pass through here. */
export function isLastHawan<T>(value: T): value is T & LastHawan {
  return LAST_HAWAN_OPTIONS.some((o) => o === value);
}
